import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlocked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.6875 6C10.6875 3.41117 8.58883 1.3125 6 1.3125C3.41117 1.3125 1.3125 3.41117 1.3125 6C1.3125 8.58883 3.41117 10.6875 6 10.6875L6 11.625C2.8934 11.625 0.375 9.1066 0.375 6C0.375 2.8934 2.8934 0.375 6 0.375C9.1066 0.375 11.625 2.8934 11.625 6C11.625 9.1066 9.1066 11.625 6 11.625L6 10.6875C8.58883 10.6875 10.6875 8.58883 10.6875 6Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.99988 6C2.99988 5.74111 3.20975 5.53125 3.46863 5.53125L8.53113 5.53125C8.79002 5.53125 8.99988 5.74111 8.99988 6C8.99988 6.25888 8.79002 6.46875 8.53113 6.46875L3.46863 6.46875C3.20975 6.46875 2.99988 6.25888 2.99988 6Z",
		fill: "currentColor"
	})] })
});
export default SvgBlocked;
